import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import R from "ramda";
import getDisplayName from "../utils/getDisplayName";
import { groupStatusMap } from "../constants/status";

const connectCommonGroups = WrappedComponent => {
  class ConnectCommonGroups extends Component {
    render() {
      const { groupsList, groups, cardExtra } = this.props;
      return R.map(name => {
        const group = groups[name];
        if (group.status === groupStatusMap.INACTIVE) {
          return null;
        }

        if (group.status === groupStatusMap.CONDITION) {
          const yesStack = cardExtra.yesStack || [];
          if (R.length(yesStack) === 0) {
            return null;
          }
        }

        return (
          <WrappedComponent
            key={name}
            injectedProps={{
              isHide: group.status === groupStatusMap.HIDE,
              group
            }}
            {...this.props}
          />
        );
      })(groupsList);
    }
  }

  ConnectCommonGroups.displayName = `ConnectCommonGroups(${getDisplayName(
    WrappedComponent
  )})`;

  ConnectCommonGroups.propTypes = {
    groupsList: PropTypes.array.isRequired,
    groups: PropTypes.object.isRequired,
    cardExtra: PropTypes.object
  };

  const mapStateToProps = ({ application }) => ({
    groups: application.groups
  });

  return connect(mapStateToProps)(ConnectCommonGroups);
};

export default connectCommonGroups;
